import {Component} from "react";
import Glob from "../../../libs/Glob.mjs";
import appLib from "../../../libs/appLib.mjs";
import TrashIcon from "../../../media/assets/TrashIcon.mjs";
import AppDislikeIcon from "../../../media/assets/AppDislikeIcon.mjs";
import AppAdminIcon from "../../../media/assets/AppAdminIcon.mjs";
import AppModIcon from "../../../media/assets/AppModIcon.mjs";
import "./AdminUtenti.css";
import MailIcon from "../../../media/assets/MailIcon.mjs";
import UserIcon from "../../../media/assets/UserIcon.mjs";
import UserDetails from "./UserDetails.mjs";

const prefix ="AdminUtenti";

const flag4user = (u, cu) => {
	if ( u.admin ) return cu.admin ? <AppAdminIcon className={"admin"} /> : <AppModIcon className={"admin"} />;
	if ( u.moderator ) return <AppModIcon className={"admin"} />;
	if ( u.disabled ) return <AppDislikeIcon className={"off disabled"} />;
	if ( u.deleted ) return <TrashIcon className={"off deleted"} />;
	return null;
}

const timeAgo = t => {
	let d = Math.round(((new Date()).getTime() - t)/60000 );
	if ( d < 2 ) return <small/>;
	if ( d < 180 ) return <div><strong>{d}</strong><span>’</span></div>;
	d = Math.round(d / 60 );
	if ( d < 48 ) return <div><strong>{d}</strong><span>h</span></div>;
	d = Math.round(d / 24 );
	if ( d < 90 ) return <div><strong>{d}</strong><span>g</span></div>;
	d = Math.round(d / 30 );
	return <div><strong>{d}</strong><span>m</span></div>;
}

const AdminUtenti = class extends Component {
	constructor(props) {
		super(props);
		this.state = {
			sortBy: 'access',
			sortAsc: true,
			user: appLib.currentUser()
		}
		this.uid = Glob.generateUid(prefix);
		this.load = this.load.bind(this);
		this.sort = this.sort.bind(this);
	}
	componentDidMount() {
		Glob.register('UserDetails', d=>{
			this.setState({ UserDetails: d } );
		}, this.uid);
		Glob.register('UsersChanged', this.load, this.uid);
		Glob.register("appPulse", this.load, this.uid);
		this.load();
	}
	componentWillUnmount() {
		Glob.deregister(this.uid);
	}
	load() {
		this.setState({busy: true}, () =>{
			appLib.api('admin/list-utenti').then((response) => {
				this.setState({utenti: response.utenti });
			}).catch((error) => {
				console.error(error);
			}).finally( ()=>{
				this.setState({busy: false});
			});
		});
	}
	sort( axle ) {
		const list = this.state.utenti;
		if ( ! list ) return list;
		const asc = this.state.sortBy === axle ? ! this.state.sortAsc : true;
		const ns = {
			sortBy: axle,
			sortAsc: asc,
		};
		if ( axle === 'access') {
			list.sort((a, b) => a.last_update - b.last_update);
			if ( asc ) list.reverse()
		} else {
			list.sort((a, b) => a[axle].toLocaleLowerCase().localeCompare(b[axle].toLocaleLowerCase()));
			if ( ! asc ) list.reverse()
		}
		ns.list = list;
		this.setState(ns);
	}
	render() {
		if ( ! this.state.utenti ) return null;
		return (
			<>
				<div className={prefix + ( this.state.busy ? " busy" : "")}>
					<table>
						<thead>
						<tr>
							<th
								className={ this.state.sortBy === 'name' ? ( this.state.sortAsc ? 'asc' : 'desc' ) : ''}
								colSpan={"2"}
								onClick={ ()=>{ this.sort("name"); } }
							><UserIcon /></th>
							<th
								className={ this.state.sortBy === 'email' ? ( this.state.sortAsc ? 'asc' : 'desc' ) : ''}
								onClick={ ()=>{ this.sort("email"); } }
							><MailIcon /></th>
							<th
								className={ this.state.sortBy === 'access' ? ( this.state.sortAsc ? 'asc' : 'desc' ) : ''}
								onClick={ ()=>{ this.sort("access"); } }
							>
								🕣
							</th>
						</tr>
						</thead>
						<tbody>
						{ this.state.utenti.map( (u,idx) => (
							<tr
								key={idx}
								onClick={()=>{ Glob.trigger('UserDetails', u?.id ) }}
							>
								<td>{ flag4user(u, this.props.user )  }</td>
								<td>{ u.name }</td>
								<td>{ u.email }</td>
								<td>{ this.state.user?.id === u?.id ? '' : timeAgo(u.last_update) }</td>
							</tr>
						) ) }
						</tbody>
					</table>
				</div>
				{ !! this.state.UserDetails && <UserDetails user={ this.state.UserDetails } /> }
			</>
		)
	}
}

export default AdminUtenti;